import { useState } from "react";
import Shell from "../components/Shell.jsx";
import { Field, inputCls } from "../components/ui.jsx";

const INCLUDED = [
  ["📊 Schedule C summary", "category totals with business-use % applied"],
  ["📒 General ledger", "every entry, CSV — opens in Excel"],
  ["🚗 IRS mileage log", "date, purpose, destination, miles, reconstructed flags"],
  ["💻 Asset worksheet", "costs, dates in service, §179 candidates"],
  ["🏠 Home office worksheet", "square footage + simplified estimate"],
  ["🏛️ Estimated payments", "what was sent to the IRS and Indiana"],
  ["🧾 Receipt images", "named by date, vendor, and amount"],
];

// One click → the year-end ZIP for the CPA. The link hits the session-gated
// API directly; the browser handles the download / share sheet.
export default function Export() {
  const thisYear = new Date().getFullYear();
  const [year, setYear] = useState(String(thisYear));

  return (
    <Shell title="CPA export" back>
      <section className="space-y-3 rounded-2xl bg-white p-5 shadow-sm">
        <p className="text-sm text-slate-600">
          Everything your CPA needs to file, in one ZIP — spreadsheets plus the receipt images. Download it, check it,
          and hand it over however you like (AirDrop, email, a USB stick on her desk).
        </p>
        <Field label="Tax year">
          <select value={year} onChange={(e) => setYear(e.target.value)} className={inputCls}>
            {[thisYear, thisYear - 1].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </Field>
        <a
          href={`/api/export/package?year=${year}`}
          download
          className="block w-full rounded-xl bg-navy-700 py-3 text-center text-sm font-semibold text-white"
        >
          📦 Download the {year} package
        </a>
      </section>

      <section className="rounded-2xl bg-white p-5 shadow-sm">
        <p className="text-sm font-semibold text-slate-700">What's inside</p>
        <ul className="mt-3 space-y-2">
          {INCLUDED.map(([title, desc]) => (
            <li key={title}>
              <p className="text-sm font-medium text-slate-800">{title}</p>
              <p className="text-xs text-slate-400">{desc}</p>
            </li>
          ))}
        </ul>
      </section>

      <p className="text-center text-xs text-slate-400">
        Straight-line and set-aside figures in the package are planning estimates — the CPA owns final treatment.
      </p>
    </Shell>
  );
}
